import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { reportWebVitals } from './lib/analytics';
import { captureAttribution } from './lib/attribution';
import './styles/globals.css';

captureAttribution();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Field Core Web Vitals — lazy, off the critical path, no-op until
// VITE_ANALYTICS_ENDPOINT is configured (see lib/analytics.ts).
void reportWebVitals();
